<template>
  <div v-if="multiple_choice">
    <h4>Multiple Choice Designer</h4>
    <ul>
      <draggable v-model="multipleChoiceShadow" @end="dragEnd">
        <li v-for="(choice, index) in multiple_choice" :key="index">
          <b-button variant="danger" size="sm" @click="remove(choice)">
            <font-awesome-icon icon="trash" />
          </b-button>
          <b-button variant="info" size="sm" @click="makeCorrectChoice(choice)">
            <font-awesome-icon v-if="choice.correct === false" icon="check" />
            <font-awesome-icon v-else icon="check-double" />
          </b-button>
          | {{choice.text}}
        </li>
      </draggable>
    </ul>
    <b-input-group>
      <b-form-input ref="newCssClass" type="text" v-model="newObject"></b-form-input>

      <b-input-group-append>
        <b-button variant="outline-success" @click="add"><font-awesome-icon icon="plus" /></b-button>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import uuidv4 from 'uuid/v4';
import EditorEvents from '../../mixins/editor-events';
import { usePageEditorStore } from '@/stores/PageEditorStore';

export default {
  name: 'PageEditorPropertiesMultipleChoice',
  mixins: [EditorEvents],
  components: {
    draggable,
  },
  props: {
    multiple_choice: Array,
    properties: Object,
    template: Object,
  },
  setup() {
    const pageEditorStore = usePageEditorStore();
    return {
      pageEditorStore,
    };
  },
  data() {
    return {
      newObject: null,
      multipleChoiceShadow: Array,
    };
  },
  created() {
    this.multipleChoiceShadow = this.multiple_choice;
  },
  watch: {
    multiple_choice() {
      this.multipleChoiceShadow = this.multiple_choice;
    },
  },
  methods: {
    remove(object) {
      if (object) {
        for (let i = 0; i < this.multiple_choice.length; i += 1) {
          const item = this.multiple_choice[i];
          if (item.id === object.id) {
            this.multiple_choice.splice(i, 1);
            this.update();
            break;
          }
        }
      }
    },
    add() {
      if (this.newObject) {
        let found = false;
        for (let i = 0; i < this.multiple_choice.length; i += 1) {
          const item = this.multiple_choice[i];
          if (item.text === this.newObject) {
            found = true;
            break;
          }
        }
        if (found === false) {
          const choice = JSON.parse(JSON.stringify(this.template));
          choice.id = uuidv4();
          choice.text = this.newObject;
          choice.order = this.multiple_choice.length + 1;
          this.multiple_choice.push(choice);
          this.update();
        }
        this.newObject = null;
      }
    },
    makeCorrectChoice(choice) {
      if (choice) {
        for (let i = 0; i < this.multiple_choice.length; i += 1) {
          if (this.multiple_choice[i].id === choice.id) {
            this.multiple_choice[i].correct = true;
          } else {
            this.multiple_choice[i].correct = false;
          }
        }
        this.update();
      }
    },
    update(data = this.multiple_choice) {
      this.$emit('onChange', data);
    },
    dragEnd() {
      this.update(this.multipleChoiceShadow);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
